
import React from 'react';
import { 
  Card, 
  CardContent 
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import TranslatedText from '@/TranslatedText';

const FeedbackSection = () => {
  const { toast } = useToast();

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6 text-center">
        <TranslatedText text="Your Feedback Matters" />
      </h2>
      <Card>
        <CardContent className="pt-6">
          <p className="text-center mb-6">
            <TranslatedText text="We're constantly working to improve our support services. Tell us how we can better assist you." />
          </p>
          <div className="flex justify-center">
            <Button 
              variant="outline" 
              className="mx-2"
              onClick={() => {
                toast({
                  title: "Feedback",
                  description: "Thank you for your feedback! We appreciate your input.",
                });
              }}
            >
              <TranslatedText text="Share Feedback" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default FeedbackSection;
